import React from 'react';
import './PageHeadingBanner.css';

/**
 * PageHeadingBanner — Reusable heading banner component for admin pages.
 *
 * @param {ReactNode}  icon        - Ant Design icon (e.g. <ShopOutlined />)
 * @param {string}     title       - Page title
 * @param {string}     subtitle    - Short description below the title
 * @param {ReactNode}  actions     - Right-side content (buttons, badges, etc.)
 * @param {string}     variant     - "orange" (default) | "dark" — controls the gradient
 * @param {string}     className   - Optional extra class name
 */
const PageHeadingBanner = ({
  icon,
  title,
  subtitle,
  actions,
  variant = 'orange',
  className = '',
}) => {
  return (
    <div className={`phb-header phb-${variant} ${className}`}>
      <div className="phb-header-left">
        {icon && <div className="phb-header-icon">{icon}</div>}
        <div>
          <h2 className="phb-header-title">{title}</h2>
          {subtitle && <p className="phb-header-subtitle">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="phb-header-actions">{actions}</div>}
    </div>
  );
};

export default PageHeadingBanner;
